(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qf-discovery-home"] && !Shopify.designMode) return;
  try {
    

(function(){
  function confirmAddition(root,form,item){
    var notice=root.querySelector('[data-qfd-confirmation]');
    var card=form.closest('.qfd-product'),photo=card.querySelector('.qfd-product-photo img');
    var title=item.product_title||item.title||card.querySelector('h3').textContent.trim();
    var src=item.image||(item.featured_image&&item.featured_image.url)||(photo&&(photo.currentSrc||photo.src));
    notice.querySelector('[data-qfd-confirm-title]').textContent=title;
    var holder=notice.querySelector('[data-qfd-confirm-image]');holder.replaceChildren();
    if(src){var img=document.createElement('img');img.src=src;img.alt='';img.width=64;img.height=64;holder.appendChild(img);}
    notice.hidden=false;
    clearTimeout(notice.qfdTimer);
    notice.qfdTimer=setTimeout(function(){if(!notice.matches(':hover')&&!notice.contains(document.activeElement))notice.hidden=true;},6500);
  }
  document.addEventListener('click',function(event){
    var close=event.target.closest('[data-qfd-confirm-close]');
    if(close){var notice=close.closest('[data-qfd-confirmation]');clearTimeout(notice.qfdTimer);notice.hidden=true;}
  });
  function select(root,key){
    var active=root.querySelector('[data-qfd-panel="'+key+'"]');
    if(!active)return;
    root.querySelectorAll('[data-qfd-panel]').forEach(function(panel){panel.hidden=panel!==active;});
    root.querySelectorAll('[data-qfd-mission]').forEach(function(button){button.setAttribute('aria-pressed',String(button.dataset.qfdMission===key));});
  }
  function initBanners(root){
    var main=root.querySelector('[data-qfd-banners]');
    if(!main)return;
    var slides=Array.from(main.querySelectorAll('.qfd-promo'));
    var controls=main.querySelector('.qfd-banner-controls');
    var dots=Array.from(main.querySelectorAll('[data-qfd-slide]'));
    var current=0,touchX=0,touchY=0;
    function go(index){
      current=(index+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        var active=i===current;
        slide.hidden=!active;
        slide.setAttribute('aria-hidden',String(!active));
        slide.inert=!active;
        dots[i].setAttribute('aria-pressed',String(active));
      });
    }
    dots.forEach(function(dot,i){dot.addEventListener('click',function(){go(i);});});
    main.addEventListener('touchstart',function(e){touchX=e.changedTouches[0].screenX;touchY=e.changedTouches[0].screenY;},{passive:true});
    main.addEventListener('touchend',function(e){
      var dx=e.changedTouches[0].screenX-touchX,dy=e.changedTouches[0].screenY-touchY;
      if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5)go(current+(dx<0?1:-1));
    },{passive:true});
    main.addEventListener('keydown',function(e){
      if(!e.target.matches('[data-qfd-slide]'))return;
      if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current+(e.key==='ArrowRight'?1:-1));dots[current].focus();}
    });
    controls.hidden=false;
    go(0);
  }
  function pageSize(){return window.matchMedia('(min-width:1101px)').matches?5:4;}
  function updateSelection(section){
    var state=section.qfdState;
    state.cards.forEach(function(card,i){card.hidden=i>=state.visible;});
    state.button.hidden=state.visible>=state.cards.length&&!state.next;
    var browse=section.querySelector('.qfd-browse-card');if(browse)browse.remove();
    if(window.matchMedia('(max-width:700px)').matches&&state.visible%2===1){
      var source=section.querySelector('.qfd-selection-footer a');
      if(source){browse=source.cloneNode(true);browse.className='qfd-browse-card';state.grid.appendChild(browse);}
    }
  }
  function initSelection(section){
    var grid=section.querySelector('.qfd-grid'),button=section.querySelector('[data-qfd-more]');if(!grid||!button)return;
    var cards=Array.from(grid.querySelectorAll('.qfd-product'));
    section.qfdState={grid:grid,button:button,cards:cards,visible:Math.min(pageSize(),cards.length),next:grid.dataset.qfdNext,busy:false,expanded:false};
    section.setAttribute('data-expanded','true');updateSelection(section);
  }
  async function loadSelection(button){
    var section=button.closest('.qfd-selection'),state=section.qfdState;if(!state||state.busy)return;
    var root=section.closest('[data-qfd-home]'),status=section.querySelector('.qfd-load-status');
    var label=button.textContent,target=state.visible+pageSize(),attempts=0;
    state.busy=true;button.disabled=true;button.textContent=root.dataset.loading;state.grid.setAttribute('aria-busy','true');if(status)status.textContent='';
    try{
      while(state.cards.length<target&&state.next&&attempts<4){
        var url=new URL(state.next,location.origin);
        if(url.origin!==location.origin)throw new Error('Unexpected collection origin');
        url.searchParams.set('section_id','qf-discovery-more');
        var response=await fetch(url.href,{headers:{Accept:'text/html'}});
        if(!response.ok)throw new Error('Collection unavailable');
        var doc=new DOMParser().parseFromString(await response.text(),'text/html'),page=doc.querySelector('[data-qfd-page]');
        if(!page)throw new Error('Collection section unavailable');
        var seen=new Set(state.cards.map(function(card){return card.dataset.qfdProduct;}));
        page.querySelectorAll('.qfd-product').forEach(function(card){
          if(seen.has(card.dataset.qfdProduct))return;seen.add(card.dataset.qfdProduct);
          card.querySelectorAll('[id]').forEach(function(el){el.id=state.grid.id+'-'+el.id;});
          card.hidden=true;state.grid.appendChild(card);state.cards.push(card);
        });
        state.next=page.dataset.next||'';attempts++;
      }
      state.visible=Math.min(target,state.cards.length);state.expanded=true;
      if(status)status.textContent=root.dataset.loaded.replace('[count]',String(state.visible));
      updateSelection(section);
    }catch(error){if(status)status.textContent=root.dataset.loadError;}
    finally{state.busy=false;button.disabled=false;button.textContent=label;state.grid.removeAttribute('aria-busy');}
  }
  var layoutTimer;
  window.addEventListener('resize',function(){
    clearTimeout(layoutTimer);layoutTimer=setTimeout(function(){
      document.querySelectorAll('.qfd-selection').forEach(function(section){
        var state=section.qfdState;if(!state)return;
        if(!state.expanded)state.visible=Math.min(pageSize(),state.cards.length);
        updateSelection(section);
      });
    },150);
  });
  function init(){
    document.querySelectorAll('[data-qfd-home]:not(.qfd-ready)').forEach(function(root){
      initBanners(root);
      var first=root.querySelector('[data-qfd-mission]');
      if(first){select(root,first.dataset.qfdMission);root.querySelector('.qfd-tabs').hidden=false;}
      root.querySelectorAll('.qfd-selection').forEach(initSelection);
      root.classList.add('qfd-ready');
    });
  }
  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-qfd-mission],[data-qfd-select],[data-qfd-more]');
    if(!button)return;
    var root=button.closest('[data-qfd-home]');
    if(!root)return;
    if(button.hasAttribute('data-qfd-more')){
      loadSelection(button);
    }else{select(root,button.dataset.qfdMission||button.dataset.qfdSelect);}
  });
  document.addEventListener('submit',async function(event){
    var form=event.target.closest('.qfd-add-form');
    if(!form)return;
    event.preventDefault();
    if(form.dataset.busy)return;
    var root=form.closest('[data-qfd-home]'),button=form.querySelector('[type=submit]'),status=form.querySelector('[role=status]'),label=button.textContent;
    form.dataset.busy='true';button.disabled=true;button.textContent=root.dataset.adding;status.textContent='';
    var confirmed=false;
    try{
      var response=await fetch(form.action.replace(/\/add\/?$/, '/add.js'),{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      var result=await response.json();
      if(!response.ok){status.textContent=result.description||result.message||root.dataset.error;return;}
      confirmed=true;status.textContent=root.dataset.added;
      confirmAddition(root,form,result);
      if(window.CartJS&&typeof window.CartJS.getCart==='function'){window.CartJS.getCart();}
      var cartResponse=await fetch((window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/')+'cart.js',{headers:{Accept:'application/json'}});
      if(cartResponse.ok){
        var cart=await cartResponse.json();
        document.querySelectorAll('[data-cart-render="item_count"],[data-cart-count],.site-header__cart-indicator').forEach(function(el){el.textContent=cart.item_count;});
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));
      }
    }catch(error){if(!confirmed)status.textContent=root.dataset.error;}
    finally{delete form.dataset.busy;button.disabled=false;button.textContent=label;}
  });
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:block:select',function(event){var panel=event.target.closest('[data-qfd-panel]');if(panel)select(panel.closest('[data-qfd-home]'),panel.dataset.qfdPanel);});
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qf-discovery-nav"]) return;
  try {
    
(function(){
  function init(){
    var button=document.getElementById('qfAllBtn'),panel=document.getElementById('qfp');
    if(!button||!panel||button.dataset.qfdAccessible)return;
    button.dataset.qfdAccessible='true';button.setAttribute('role','button');button.tabIndex=0;button.setAttribute('aria-controls','qfp');button.setAttribute('aria-expanded',String(panel.classList.contains('open')));
    button.addEventListener('keydown',function(event){if(event.key==='Enter'||event.key===' '){event.preventDefault();panel.classList.toggle('open');}});
    button.addEventListener('click',function(){panel.classList.add('open');});
    panel.addEventListener('focusin',function(event){var category=event.target.closest('[data-d]');if(category&&typeof window.qfD==='function')window.qfD(category);});
    new MutationObserver(function(){button.setAttribute('aria-expanded',String(panel.classList.contains('open')));}).observe(panel,{attributes:true,attributeFilter:['class']});
    document.addEventListener('keydown',function(event){if(event.key==='Escape'&&panel.classList.contains('open')){panel.classList.remove('open');button.focus();}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

  } catch(e) { console.error(e); }
})();
})();
